module.exports = __webpack_public_path__ + "img/Samoa.e64f0e0c.svg";